import styled from 'styled-components'

const HeroSectionStyle = styled.div`
	--iconSize: var(--sp19x);
	--mainTitleMaxWidth: var(--sp161x);
	--videoWidth: 27.9%;
	--videoMarginTop: calc(var(--sp12-5x) * -1);
	--firstVideoMarginLeft: var(--sp29-5x);
	--lottieMarginLeft: var(--sp17-5x);
	--lottieWidth: 15.5%;
	--secondLineMarginTop: var(--sp12x);
	--secondVideoMarginLeft: var(--sp74x);
	--secondVideoMarginTop: var(--sp5-5x);
	--subscribeWrap: var(--sp40x);
	--subscribeWrapMarginTop: var(--sp22-5x);
	--subscribeIconSize: var(--sp15x);

	.animStartPos {
		transform: translateY(200%);
	}

	.icon-crown {
		position: absolute;
		width: var(--iconSize);
		height: var(--iconSize);
		transform: rotate(15deg);
        fill: var(--orange);
	}

	.secondVideoWrapMobile {
		position: relative;
		overflow: hidden;
		.blackLayer {
			position: absolute;
			bottom: 0;
			left: 0;
			background-color: var(--black);
			width: 100%;
			height: 100%;
		}
	}

	.scaleBeforeAnim {
		transform: scale(0);
	}

	.crownWrap {
		display: block;
		position: absolute;
		top: -60%;
		left: 83%;
	}

	.mobileVideo {
		width: 65.8%;
		margin-top: var(--secondVideoMarginTop);
		margin-left: var(--secondVideoMarginLeft);
	}

	.mainTitle {
		display: inline-block;
		width: 100%;
		max-width: var(--mainTitleMaxWidth);

		.titleFirstLine {
			width: fit-content;
		}
	}

	.firstVideoWrap {
		width: var(--videoWidth);
		margin-left: var(--firstVideoMarginLeft);
		margin-top: var(--videoMarginTop);
		position: relative;
		overflow: hidden;
		.blackLayer {
			position: absolute;
			bottom: 0;
			left: 0;
			background-color: var(--black);
			width: 100%;
			height: 100%;
		}
		.firstVideo {
			width: 100%;
			height: 100%;
		}
	}

	.secondLineWrap {
		margin-top: var(--secondLineMarginTop);
		.lottieMainWrap {
			width: var(--lottieWidth);
			margin-left: var(--lottieMarginLeft);
			height: fit-content;
            transform: translateY(200%);
		}

		.secondVideoWrap {
			height: fit-content;
			width: var(--videoWidth);
			margin-left: var(--secondVideoMarginLeft);
			margin-top: var(--secondVideoMarginTop);
			position: relative;
			overflow: hidden;

			.blackLayer {
				position: absolute;
				bottom: 0;
				left: 0;
				background-color: var(--black);
				width: 100%;
				height: 100%;
			}

			.secondVideo {
				width: 100%;
				height: 100%;
			}
		}

		.subscribeWrap {
			max-width: var(--subscribeWrap);
			width: 100%;
			margin-left: auto;
			margin-top: var(--subscribeWrapMarginTop);
			height: fit-content;

			.imageCont {
				width: 100%;
				padding-top: 100%;
				animation: wheel 5s linear infinite;

				@keyframes wheel {
					0% {
						transform: rotate(0deg);
					}
					100% {
						transform: rotate(360deg);
					}
				}
			}
			i {
				font-size: var(--subscribeIconSize);
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--iconSize: var(--sp16x);
		--mainTitleMaxWidth: var(--sp125x);
		--videoWidth: 26.4%;
		--firstVideoMarginLeft: var(--sp23x);
		--videoMarginTop: calc(var(--sp8x) * -1);
		--lottieMarginLeft: var(--sp4x);
		--lottieWidth: 18.1%;
		--secondLineMarginTop: 0;
		--secondVideoMarginLeft: var(--sp68x);
		--secondVideoMarginTop: var(--sp18x);
		--subscribeWrap: var(--sp31x);
		--subscribeIconSize: var(--sp12x);
		--subscribeWrapMarginTop: var(--sp25x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--iconSize: var(--sp13x);
		--mainTitleMaxWidth: var(--sp87-5x);
		--videoWidth: 27.8%;
		--firstVideoMarginLeft: var(--sp15x);
		--videoMarginTop: calc(var(--spSize) * -1);
		--lottieMarginLeft: 0;
		--lottieWidth: 21.5%;
		--secondLineMarginTop: 0;
		--secondVideoMarginLeft: var(--sp41x);
		--secondVideoMarginTop: var(--sp15x);
		--subscribeWrap: var(--sp27-5x);
		--subscribeIconSize: var(--sp10x);
		--subscribeWrapMarginTop: var(--sp22-5x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--iconSize: var(--sp9x);
		--mainTitleMaxWidth: var(--sp62-5x);
		--videoWidth: 29.7%;
		--firstVideoMarginLeft: var(--sp9x);
		--videoMarginTop: calc(var(--spSize) * -1);
		--lottieMarginLeft: 0;
		--lottieWidth: 25%;
		--secondLineMarginTop: 0;
		--secondVideoMarginLeft: var(--sp17x);
		--secondVideoMarginTop: var(--sp7x);
		--subscribeWrap: var(--sp22-5x);
		--subscribeIconSize: var(--sp8x);
		--subscribeWrapMarginTop: var(--sp19x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--iconSize: var(--sp9x);
		--mainTitleMaxWidth: var(--sp65x);
		--videoWidth: 39.8%;
		--firstVideoMarginLeft: auto;
		--videoMarginTop: var(--sp2x);
		--lottieMarginLeft: 0;
		--lottieWidth: 34.8%;
		--secondLineMarginTop: var(--sp6x);
		--secondVideoMarginLeft: var(--sp2x);
		--secondVideoMarginTop: 0;
		--subscribeWrap: var(--sp22-5x);
		--subscribeIconSize: var(--sp8x);
		--subscribeWrapMarginTop: var(--sp19x);

		.secondLineWrap {
			.subscribeWrap {
				margin-left: -4%;
			}
		}

		.firstLineWrap {
			flex-direction: column;
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--iconSize: var(--sp7x);
		--mainTitleMaxWidth: var(--sp31x);
		--videoWidth: 65.8%;
		--firstVideoMarginLeft: auto;
		--videoMarginTop: var(--sp4x);
		--lottieMarginLeft: 0;
		--lottieWidth: 48.1%;
		--secondLineMarginTop: var(--sp3x);
		--secondVideoMarginLeft: var(--sp3-5x);
		--secondVideoMarginTop: var(--sp4x);
		--subscribeWrap: var(--sp20x);
		--subscribeIconSize: var(--sp7x);
		--subscribeWrapMarginTop: var(--sp14x);

		.crownWrap {
			top: -90%;
			left: 90%;
		}

		.secondLineWrap {
			.subscribeWrap {
				margin-left: var(--spSize);
			}
		}

		.firstLineWrap {
			flex-direction: column;
		}
	}
`

export default HeroSectionStyle
